import { render, staticRenderFns } from "./AgentManagement.vue?vue&type=template&id=6f38fd70&scoped=true"
import script from "./AgentManagement.vue?vue&type=script&lang=js"
export * from "./AgentManagement.vue?vue&type=script&lang=js"
import style0 from "./AgentManagement.vue?vue&type=style&index=0&id=6f38fd70&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f38fd70",
  null
  
)

export default component.exports